import React from "react";
import { useContext } from "react";
import AuthContext from "connections/auth/AuthProvider";

// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// import { makeStyles } from "@mui/styles";
// @material-ui/icons

// core components
import styles from "assets/jss/material-dashboard-pro-react/components/cardIconStyle.js";

export default function CardIcon(props) {
  let { userDetails } = useContext(AuthContext);
  const client_styles = () => ({
    ...styles(userDetails ? userDetails.implementation_color : "#888"),
  });
  const useStyles = makeStyles(client_styles);
  const classes = useStyles();
  const { className, children, color, ...rest } = props;
  const cardIconClasses = classNames({
    [classes.cardIcon]: true,
    [classes[color + "CardHeader"]]: color,
    [className]: className !== undefined,
  });
  return (
    <div className={cardIconClasses} {...rest}>
      {children}
    </div>
  );
}

CardIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf([
    "client",
    "integration",
    "warning",
    "success",
    "danger",
    "info",
    "primary",
    "rose",
  ]),
  children: PropTypes.node,
};
